module.exports = __webpack_public_path__ + "img/full4-min.8d0a1eae.png";